import React from 'react';
import classNames from 'classnames';

import ArrowLeft from './icons/arrow_left';
import ArrowRight from './icons/arrow_right';

import styles from './IconButton.module.scss';

type Icon = 'arrow_left' | 'arrow_right';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  asChild?: true;
  icon?: Icon;
  iconSize?: number;
};
type DivProps = React.HTMLAttributes<HTMLDivElement> & {
  asChild?: false;
  icon?: Icon;
  iconSize?: number;
};

type Props = ButtonProps | DivProps;

function IconButton(props: Props) {
  const {
    className,
    children,
    icon,
    iconSize,
    asChild = false,
    ...restProps
  } = props;

  if (asChild) {
    // Div
    return (
      <div
        className={classNames(styles.root, className)}
        {...(restProps as React.HTMLAttributes<HTMLDivElement>)}
      >
        {icon === 'arrow_left' && (
          <ArrowLeft size={iconSize} color={(restProps as any).color} />
        )}
        {icon === 'arrow_right' && (
          <ArrowRight size={iconSize} color={(restProps as any).color} />
        )}
        {children}
      </div>
    );
  }

  // Button
  return (
    <button
      className={classNames(styles.root, className)}
      {...(restProps as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {icon === 'arrow_left' && (
        <ArrowLeft size={iconSize} color={(restProps as any).color} />
      )}
      {icon === 'arrow_right' && (
        <ArrowRight size={iconSize} color={(restProps as any).color} />
      )}
      {children}
    </button>
  );
}

export default IconButton;
